import React from 'react';
import { FlatButton } from 'material-ui';
import WidgetList from '../../editor/components/WidgetList';
import { connect } from 'react-redux';
import { compose, branch, renderComponent, renderNothing } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withLeagueWidgets } from '../hoc/widgets';

const LeagueOverview2 = ({ tournamentId, template }) => (
    <div>
        <LeagueWidgetsPage tournamentId={tournamentId} template={template} groupBy="category" wdpcache="state" />
    </div>
);

LeagueOverview2.defaultProps = {
    wdpcache: 'state',
};

LeagueOverview2.propTypes = {
    onLeagueSelected: PropTypes.func.isRequired,
    onTeamSelected: PropTypes.func.isRequired,
    template: PropTypes.string.isRequired,
};

const NoWidgets = () => <div style={{ textAlign: 'center', padding: 15 }}>Please select league above</div>;

const LeagueWidgets = withLeagueWidgets(WidgetList);

const LeagueWidgetsPage = compose(branch(({ tournamentId }) => !tournamentId, renderComponent(NoWidgets)))(
    LeagueWidgets,
);

export default LeagueOverview2;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/containers/LeagueOverview.js
 **/